<template>
    <div class="form-box">
        <!------------------- login form -------------------------->

        <div class="login-container" id="login">
            <div class="top">
                <span>Don't have an account? Call me to get one.</span>
                <header>Login</header>
            </div>
            <div class="input-box">
                <input type="text" class="input-field" placeholder="Username or Email" v-model="email">
                <i class="fa-solid fa-user"></i>
            </div>
            <div class="input-box">
                <input type="password" class="input-field" placeholder="Password" v-model="password">
                <i class="fa-solid fa-lock"></i>
            </div>
            <div class="input-box">
                <input type="submit" class="submit" value="Sign In" @click="login">
            </div>

            <div class="error-message" v-show="error"> {{ this.errorMsg }}</div>
            <div class="two-col">
                <div class="two">
                    <router-link class="link" :to="{ name: 'ForgotPassword' }">Forgot Password?</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db, auth } from '@/firebase/FirebaseInit'
import { mapActions, mapMutations, mapState } from 'vuex'
import 'firebase/auth'

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            error: null,
            errorMsg: "", 
        }
    },

    methods: {
        ...mapActions(['LOGIN']),
        ...mapMutations(['LOGIN_SUCCESSFUL', 'SET_USER', 'LOGOUT']),

        async login() {
            this.error = false; // Set error to false before the try block
            try {
                await this.LOGIN({ email: this.email, password: this.password, router: this.$router });
                this.$toast.open({
                    message: 'Login Successful.... Redirecting',
                    type: 'success',
                    position: 'bottom-right',
                    duration: 3000,
                })
            } catch (err) {
                this.error = true;
                this.errorMsg = err.message;

                this.$toast.open({
                    message: 'Login error',
                    type: 'error',
                    position: 'top',
                    duration: 3000,
                });
            }
        },

    },
}
</script>

<style lang="scss" scoped>
::-webkit-input-placeholder{
    color: #fff;
}

.form-box{
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    z-index: 100000;
    width: 100%;
    min-height: 100vh;

    .login-container{
        max-width: 600px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        transition: .5s ease-in-out;
        padding: 3rem;

        .top {
            margin: 1.5rem 0;

            span {
                display: flex;
                justify-content: center;
                padding-bottom: .7rem;

                a {
                    margin-left: .2rem;
                }
            }

            header {
                font-size: 1.2rem;
                font-weight: 600;

            }
        }

        .input-box {
            display: flex;
            position: relative;
            padding: .4rem 0;
            width: 100%;

            input {
                font-size: 15px;
                background: rgba(255, 255, 255, 0.281);
                color: white;
                height: 50px;
                width: 100%;
                padding: 0 10px 0 45px;
                border: none;
                border-radius: 15px;
                outline: none;
                transition: .2s ease;

                &:hover, &:focus {
                    background: rgba(255, 255, 255, 0.25);
                }
            }

            i {
                position: absolute;
                top: 20px;
                left: 5%;
                font-size: 1.2rem;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                color: black;
            }
            
            .submit{
                font-size: 15px;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 500;
                color: black;
                height: 45px;
                width: 100%;
                text-align: center;
                border: none;
                border-radius: 15px;
                outline: none;
                background: rgba(255, 255, 255, 0.7);
                cursor: pointer;
                transition: .3s ease-in-out;

                &:hover{
                    background: rgba(255, 255, 255, 0.5);
                    box-shadow: 1px 5px 7px 1px rgba(0, 0, 0, 0.2);
                }
            }
        }

        .two-col{
            display: flex;
            justify-content: center;
            color: #fff;
            font-size: small;
            margin-top: 2rem;
            z-index: 2000 !important;

            .two .link{
                text-decoration: none;
                color: #fff;

                &:hover{
                    text-decoration: underline;
                }
            }

        }
    }

        .error-message {
            color: red;
            margin-top: 10px;
            z-index: 100;
        }

}

</style>